import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});

// ✅ ICONA AI - Stile "Brain/Cervello"
export const AIBrainMarkerIcon = L.divIcon({
    html: `
    <div style="
      width: 30px;
      height: 30px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: 2px solid white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 3px 8px rgba(102, 126, 234, 0.6);
      cursor: pointer;
    ">
      <span style="font-size: 18px; line-height: 1;">🧠</span>
    </div>
  `,
    className: 'ai-marker-icon', // ✅ Classe semplice per CSS
    iconSize: [30, 30],
    iconAnchor: [15, 30], // ✅ Ancora in basso al centro (come un pin)
    popupAnchor: [0, -30] // ✅ Popup sopra l'icona
});